module.exports = __webpack_public_path__ + "a286ed73c485bf06fd15025de7487aac.pdf";